import React, { useEffect, useState } from "react";
import { Button, Table, message } from "antd";
import { getWorkflowsApi } from "../../../apiservice/ats";
import { useNavigate } from "react-router-dom";

export default function WorkflowList() {
  const [workflows, setWorkflows] = useState([]);
  const [editingWorkflowId, setEditingWorkflowId] = useState(null);
  const navigate = useNavigate();

  // Table columns
  const columns = [
    { title: "ID", dataIndex: "id", key: "id", hidden: true },
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => new Date(value).toLocaleString(),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => setEditingWorkflowId(record.id)}>
          Edit
        </Button>
      ),
    },
  ];

  useEffect(() => {
    fetchWorkflows();
  }, []);

  const fetchWorkflows = async () => {
    try {
      const rawData = await getWorkflowsApi();
      const dataArray = Array.isArray(rawData) ? rawData : rawData.data || [];
      setWorkflows(dataArray);
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch workflows");
    }
  };



  return (
    <div className="p-4 w-full">
      {!editingWorkflowId ? (
        <>
          {/* Header */}
          <div className="flex justify-between items-center w-full mb-6">
            <h2 className="text-xl font-semibold">Workflows</h2>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                className="mr-4"
                style={{ padding: "6px 18px", marginBottom: "15px", alignContent: "right" }}
                onClick={() => navigate(`/ats/workflow/new`)}
              >
                + Create New Workflow
              </Button>
            </div>
          </div>
          {/* Workflow Table */}
          <Table
            rowKey="id"
            dataSource={workflows}
            columns={columns.map(col => {
              // Add edit button for each row
              if (col.key === 'actions') {
                return {
                  ...col,
                  render: (_, record) => (
                    <Button onClick={() => navigate(`/ats/workflow/${record.id}`)}>
                      Edit
                    </Button>
                  ),
                };
              }
              return col;
            })}
            bordered
          />
        </>
      ) : null}
    </div>
  );
}
